import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { openTermsAndConditionsDialog, socialMediaClicked } from '@app-core/components/home/home.component';
import { UserService } from '@app-services/user/user.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit  {
  searchValue: any = '';
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  constructor(private dialog: MatDialog,
    private gaService: GAnalyticsService,
    private userService: UserService) { }

  ngOnInit(): void {
    this.gaService.sendEvent(
      'About us page viewed',
      '',
      '',
      '',
      {
        'event': 'About us page viewed',
        'Navigated to which page': 'About us',

      }
    )
  }

  ngOnDestroy(){
  }
}
